module.exports = __webpack_public_path__ + "static/media/uncheck.2af9cb99.svg";